export default {
    //中文
    DiagnosticReport:'诊断报告',
    troubleCode:'故障码',
    time:'时间',
    // 语言
    lang:{
        cn:'中文',
        de:'德语',
        en:'英语',
        es:'西班牙语',
        fr:'法语',
        it:'意大利语',
        ja:'日语',
        ko:'韩语',
        pt:'葡萄牙语'
    },
    PositioningPrompt:'开启定位功能以获取当地价格。',
    FaultCode:'故障代码',
    AIDiagnosis:'AI诊断',
    AIWait:'AI报告或等待自动诊断',
    FailedFaultCode:'无法获取故障代码信息',
    AIError:'AI分析失败',
    more:'更多',
    StoredCodes:'存储代码',
    PendingCodes:'待处理代码',
    PermanentCodes:'永久编码',
    Unknown:'未知的',
    ManufacturerControl:'制造商控制'
}